<template>
  <div>
    <div v-for="(page, index) in pageGroupedElements" :key="'page-' + index" class="position-relative dinA4">
      <img :src="require('@/assets/insular-header.png')" class="mb-0 page__header" />
      <div class="page__container">
        <div v-for="(element, elementIndex) in page" :key="'element-' + elementIndex">
          <div v-if="element.type === 'table'" class="d-flex justify-center" :class="{ 'mt-10': elementIndex > 0 }">
            <PdfProductTable v-for="(id, i) in element.ids" :key="'table-' + i" :type="element.tableType"
              :tableData="productTableList[id]" :tableId="id" :image="i === 0 && element.imageUrl" />
          </div>
          <div v-else class="d-flex justify-center mt-5">
            <div :class="element.extraWide ? 'small-letter-section-extrawide' : 'small-letter-section'">
              <p class="small-letter-font small-letter-font--bold mb-0">
                {{ element.intro }}
              </p>
              <ul class="small-letter-font justify-text spaced-list">
                <li v-for="(elementList, listIndex) in element.list" :key="'elementList' + listIndex"
                  v-html="elementList" />
              </ul>
              <p v-if="element.outro" class="small-letter-font justify-text mt-6 mb-0" v-html="element.outro" />
            </div>
          </div>
        </div>
      </div>

      <Footer logo :page="previousPages + 1 + index" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { GET_PDF_PRODUCT_TABLE_LIST } from '@/store/modules/offer/getters'
import PdfProductTable from '@/containers/offer-form/sign-off/pdf-venta-directa-2026-v2/PdfProductTable'
import Footer from '@/containers/offer-form/sign-off/pdf-venta-directa-2026-v2/Footer'

export default {
  name: 'InsularTables',
  components: {
    PdfProductTable,
    Footer,
  },
  data() {
    return {
      elements: [
        {
          type: 'table',
          imageUrl: require('@/assets/cttcanarias-icon.png'),
          ids: ['CANEXPRESS','CCA24'],
          tableType: 'cannary',
        },
        {
          type: 'table',
          ids: ['CCA48','CANMARITIMO'],
          tableType: 'cannary',
        },
        {
          type: 'text',
          relatedTableType: 'cannary',
          extraWide: true,
          intro: 'Características de los servicios CTT Canarias (LPA - TNF / Resto de Islas):',
          list: [
            '- Peso máximo por bulto: 30 kg.',
            '- Medidas máximas por bulto: suma de alto, ancho y largo no superior a 240 cm con ninguna superior a 150 cm. No admite exceso de peso y de medidas.',
            '- Cubicaje: Conversión volumétrica 167kg/m3 aéreo y 333 kg/m3 marítimo.',
            '- CTT Canarias Documentación: Entrega en 24h. Servicio válido solo para envíos de documentación.',
            '- CTT Canarias Aéreo 24h: Entrega en 24h TLF / LPA y 48h Islas Menores. Incluye DUA y Trámites de Gestión Aduanera Simplificada (GAS). No incluye el IVA y otros impuestos por el valor declarado.',
            '- CTT Canarias Aéreo 48h: Entrega en 48h TLF / LPA y 72h Islas Menores. Incluye DUA y Trámites de Gestión Aduanera Simplificada (GAS). No incluye el IVA y otros impuestos por el valor declarado.',
            '- CTT Canarias Marítimo: Entrega en 3-4 días con 3 conexiones marítimas semanales a Canarias. El servicio "Islas Mayores" e "Islas Menores" incluye DUA y Trámites de Gestión Aduanera Simplificada (GAS). No incluye el IVA y otros impuestos por el valor declarado.',
            'Nota: Los tiempos de tránsito podrían verse incrementados por Trámites de Gestión Aduanera ajenos a CTT Express.',
          ],
        },
        {
          type: 'table',
          imageUrl: require('@/assets/cttbaleares-icon.png'),
          ids: ['BALEXPRESS', 'BALECONOMY'],
          tableType: 'balear',
        },
        {
          type: 'text',
          relatedTableType: 'balear',
          extraWide: true,
          intro: 'Características de los servicios CTT Baleares (Mallorca / Resto de Islas):',
          list: [
            '- Peso máximo por bulto: 30 kg.',
            '- Medidas máximas por bulto: Suma de alto, ancho y largo no superior a 240 cm con ninguna superior a 150 cm. No admite exceso de peso y de medidas.',
            '- Cubicaje: Conversión volumétrica 167 kg/m3.',
            '- CTT Baleares Express: Entrega en 24h Mallorca y 48h Islas Menores e Interislas.',
            '- CTT Baleares Economy: Entrega en 48h Mallorca y 72h Islas Menores e Interislas.',
          ],
        },
        {
          type: 'table',
          imageUrl: require('@/assets/cttotherdest-icon.png'),
          ids: ['OTHERDESTINATIONS'],
          tableType: 'otherDestinations',
          forceNewPage: true,
        },
        {
          type: 'text',
          relatedTableType: 'otherDestinations',
          extraWide: true,
          intro:
            'Características de los servicios Ceuta, Melilla, Gibraltar, Andorra e Islas Portugal:',
          list: [
            '- Peso máximo por bulto: 30 kg (Islas Portugal Aéreo: Madeira hasta 20kg; Azores hasta 5kg).',
            '- Medidas máximas por bulto: Suma de alto, ancho y largo no superior a 240 cm con ninguna superior a 150 cm. No admite exceso de peso y de medidas.',
            '- Cubicaje: Conversión volumétrica 167kg/m3 (Ceuta, Melilla e Islas Portugal Marítimo 333 kg/m3).',
            '- Impuestos e IVA no incluidos. Ver página de Servicios Aduaneros.',
            '- CTT Otros Destinos: Entrega en 48h a Ceuta, Melilla, Gibraltar, Andorra e Islas Portugal Aéreo.',
            '- CTT Otros Destinos: Entrega en 7-15 días en Islas Portugal marítimo.',
            '- Islas Portugal: no es necesario documentación adicional (Territorio intracomunitario).',
          ],
        },
      ],
      previousPages: 0,
    }
  },
  computed: {
    ...mapGetters('offer', [GET_PDF_PRODUCT_TABLE_LIST]),
    productTableList() {
      return this[GET_PDF_PRODUCT_TABLE_LIST]
    },
    pageGroupedElements() {
      let pages = []
      let pageGroup = []
      let singleRow = false
      let doubleRow = false
      let rowElementCounter = 0

      for (let i = 0; i < this.elements.length; i++) {
        let actualElement = this.elements[i]
        
        // Forzar nueva página si el elemento tiene el flag forceNewPage
        if (actualElement.forceNewPage && pageGroup.length > 0) {
          pages.push(pageGroup)
          pageGroup = []
          rowElementCounter = 0
          doubleRow = false
          singleRow = false
        }
        
        if (actualElement.type !== 'text') {
          for (const id of actualElement.ids) {
            const numberOfRows = Object.keys(this.productTableList[id].kgRows).length

            if (numberOfRows > 15) {
              singleRow = true
            } else if (numberOfRows > 7) {
              doubleRow = true
            }
          }
        }
        if (singleRow) {
          if (rowElementCounter !== 0) {
            pages.push(pageGroup)
            pageGroup = []
            rowElementCounter = 0
            doubleRow = false
          }
          pageGroup.push(actualElement)
          pages.push(pageGroup)
          pageGroup = []
          singleRow = false
        } else if (doubleRow) {
          pageGroup.push(actualElement)
          rowElementCounter++
          if (rowElementCounter === 2 || rowElementCounter === this.elements.length) {
            pages.push(pageGroup)
            pageGroup = []
            rowElementCounter = 0
            doubleRow = false
          }
        } else {
          pageGroup.push(actualElement)
          rowElementCounter++
          if (
            (rowElementCounter === 2 &&
              actualElement.type === 'text' &&
              actualElement.relatedTableType === 'cannary' &&
              this.elements.filter(
                element => element.type === 'table' && element.tableType === 'cannary',
              ).length === 1) ||
            (rowElementCounter === 3 && actualElement.type !== 'table') ||
            (rowElementCounter === 4 &&
              actualElement.type === 'text' &&
              actualElement.relatedTableType !== ' balear') ||
            (actualElement.relatedTableType === 'otherDestinations' && actualElement.type === 'text') ||
            i === this.elements.length - 1
          ) {
            pages.push(pageGroup)
            pageGroup = []
            rowElementCounter = 0
          }
        }
      }
      return pages
    },
  },
  created() {
    this.$emit('updateTotalPages', { InsularTables: this.pageGroupedElements.length })
  },
  mounted() {
    this.previousPages = this.$parent.sectionPreviousPages('InsularTables')
  },
}
</script>
